import { render, staticRenderFns } from "./StockAnalytics.vue?vue&type=template&id=3afce054&scoped=true"
import script from "./StockAnalytics.vue?vue&type=script&lang=js"
export * from "./StockAnalytics.vue?vue&type=script&lang=js"
import style0 from "./StockAnalytics.vue?vue&type=style&index=0&id=3afce054&prod&lang=css"
import style1 from "./StockAnalytics.vue?vue&type=style&index=1&id=3afce054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afce054",
  null
  
)

export default component.exports